import { useEffect, useState } from "react";
import { fetchPrivateMedia, isPrivateMedia } from "../utils/privateMedia";

export default function usePrivateMedia(source) {
  const [result, setResult] = useState({ source: null, url: undefined, error: null });
  useEffect(() => {
    if (!source || !isPrivateMedia(source)) return undefined;
    const controller = new AbortController();
    let active = true;
    let media;
    fetchPrivateMedia(source, controller.signal).then(value => {
      if (!active) { value.release(); return; }
      media = value;
      setResult({ source, url: value.url, error: null });
    }).catch(error => {
      if (active && error.name !== "AbortError") setResult({ source, url: undefined, error });
    });
    return () => { active = false; controller.abort(); if (media) media.release(); };
  }, [source]);
  if (!source || !isPrivateMedia(source)) return { url: source, error: null };
  return result.source === source ? result : { url: undefined, error: null };
}
